/**
@ngdoc directive
@name delaySubmit

@description
Prevents to early form submission - before all angular variables have been evaluated (ie. hidden fields)<br />
specifically used for global (top) search in conjunction with tag-box-input directive and hidden field
*/
(function() {

    var delaySubmit = function($timeout) {
        return {
            restrict: "A",
            require: 'form', // parent form binding
            link: function(scope, element, attrs, formCtrl) {

                element.one("submit", function(event){
                    console.log('test');
                    event.preventDefault();
                    $timeout(function(){
                        element.submit();
                    });
                });

            }

        };
    }
    delaySubmit.$inject = ['$timeout'];
    angular.module('app').directive('delaySubmit', delaySubmit);

}());